import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {emptyProductSheetObject, IProductSheet} from "../../../interfaces/IProductSheet";
import {getSheetByNumber} from "../../../utility/FetchAPI";
import {showPdfInNewTab} from "../../../utility/Helper";
import {useLanguageMappings} from '../../../globals/LanguageMappingsContext';
import {useTranslation} from "react-i18next";


export const SheetPdf = () => {
    let navigate = useNavigate();
    const languageMappings = useLanguageMappings();

    const {t, i18n} = useTranslation();
    const mapping = languageMappings[i18n.language] || languageMappings['en'];
    let {sheetNumber, language} = useParams<{
        sheetNumber: string;
        language: string;
    }>();
    const [sheet, setSheet] = useState<IProductSheet>(emptyProductSheetObject);
    useEffect(() => {
        if (sheetNumber != null) {
            getSheetByNumber(sheetNumber).then((results: any) => {
                showPdfInNewTab({
                    sheet: results.data,
                    language: i18n.language,
                    navigate,
                    mapping,
                    newWindow: false,
                    t,
                    i18n
                });
            });
        }
    }, [sheetNumber, language]);

    return (<></>);
}